import { render, staticRenderFns } from "./zh.vue?vue&type=template&id=ade70648&scoped=true&"
import script from "./zh.vue?vue&type=script&lang=js&"
export * from "./zh.vue?vue&type=script&lang=js&"
import style0 from "./zh.vue?vue&type=style&index=0&id=ade70648&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade70648",
  null
  
)

export default component.exports